import type { ButtonHTMLAttributes, ReactNode } from 'react';
import css from './Chip.module.css';

interface PropsChip extends ButtonHTMLAttributes<HTMLButtonElement> {
  /** Escolha marcada (motivo, forma): vira botão de alternar (aria-pressed). Sem ela, é ação. */
  pressionado?: boolean;
  tom?: 'normal' | 'perigo';
  /** Texto menor ao lado ("R$ 115"). */
  detalhe?: ReactNode;
}

/** Botão em pílula da lista e dos diálogos ("Sai com Carlos", motivos, produtos): 32 px, 44 px no celular. */
export function Chip({
  pressionado,
  tom = 'normal',
  detalhe,
  className,
  children,
  type = 'button',
  ...resto
}: PropsChip) {
  return (
    <button
      type={type}
      aria-pressed={pressionado}
      className={[css.chip, tom === 'perigo' && css.perigo, className].filter(Boolean).join(' ')}
      {...resto}
    >
      {children}
      {detalhe !== undefined && detalhe !== null && (
        <small className={css.detalhe}>{detalhe}</small>
      )}
    </button>
  );
}
